var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "import_outline",
    "data-name": "import/outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_import",
    "data-name": "vuesax/outline/import"
  }, /*#__PURE__*/React.createElement("g", {
    id: "import"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.308,4.058a.742.742,0,0,1-.53-.22L.218,1.278A.75.75,0,0,1,1.278.218l2.03,2.03L5.338.218A.75.75,0,0,1,6.4,1.278l-2.56,2.56A.742.742,0,0,1,3.308,4.058Z",
    transform: "translate(8.573 10.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.75,11.67A.755.755,0,0,1,0,10.92V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V10.92A.755.755,0,0,1,.75,11.67Z",
    transform: "translate(11.13 3.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.75,9.5A8.374,8.374,0,0,1,0,.75.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75,6.935,6.935,0,0,0,8.75,8,6.935,6.935,0,0,0,16,.75a.75.75,0,0,1,1.5,0A8.374,8.374,0,0,1,8.75,9.5Z",
    transform: "translate(3.25 11.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportOutline);
export default __webpack_public_path__ + "static/media/import-outline.bb1d3fb5e339a8ea3ec087aaf497227b.svg";
export { ForwardRef as ReactComponent };